import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OffersOfApplication, Promotion } from '../../../../type/result_type';
import { OfferType, PopupEventType } from '../../../../type/offer_type';

@Component({
  selector: 'app-cashback',
  templateUrl: './cashback.component.html',
  styleUrls: ['./cashback.component.scss'],
})
export class CashbackComponent implements OnInit {
  @Input() cashbackData!: Promotion;
  @Input() popup!: OfferType['popup'];
  @Input() sliderWrapper!: boolean;
  @Input() cardId!: OffersOfApplication['id'];

  @Output() cashBackPopupChange = new EventEmitter<boolean>();

  public showPopup: boolean =
    (this.popup?.['cashback'] && this.popup['cashback'] === this.cardId) ??
    false;
  private isTouchEvent: boolean = false;

  constructor() {}

  ngOnInit(): void {
    this.showPopup =
      this.popup?.['cashback'] && this.popup['cashback'] === this.cardId;
  }

  getTextStyles(): { [key: string]: string } {
    if (this.cashbackData?.backgroundColor && this.cashbackData?.textColor) {
      return {
        'background-color': this.cashbackData.backgroundColor,
        'color': this.cashbackData.textColor
      };
    }
    return {};
  }

  openPopup(): void {
    this.showPopup = true;
    this.cashBackPopupChange.emit(true);
  }

  closePopup(): void {
    this.showPopup = false;
    this.cashBackPopupChange.emit(false);
  }

  mouseEvent(openPopup: boolean): void {
    if (!this.isTouchEvent) {
      openPopup ? this.openPopup() : this.closePopup();
    }
  }

  touchEvent(): void {
    this.isTouchEvent = true;
    this.openPopup();
  }

  popupEvent(value: PopupEventType): void {
    value.openPopup ? this.openPopup() : this.closePopup();
  }
}
